import * as Scrivito from "scrivito";
import defaultPageAttributes from "../_defaultPageAttributes";
import TRAINING_CATEGORIES from "./_trainingCategories";

const categoryKeys = TRAINING_CATEGORIES.map((c) => c.key);

const TrainingCoursePage = Scrivito.provideObjClass("TrainingCoursePage", {
  onlyInside: ["TrainingCatalogPage"],
  attributes: {
    ...defaultPageAttributes,
    body: "widgetlist",
    image: ["reference", { only: "Image" }],
    format: ["enum", { values: ["online", "presence"] }],
    category: ["multienum", { values: categoryKeys }],
    isFullyBooked: "boolean",
    provider: "string",
    location: "string",
    startDate: "datetime",
    endDate: "datetime",
    speaker: "string",
    transferSupport: "string",
    contactEmail: "string",
    appointments: ["widgetlist", { only: "CollapseWidget" }],
  },
  extractTextAttributes: ["body", "title", "description", "segmentName"],
});

export default TrainingCoursePage;
